// src/middleware/socketMiddleware.js
import { createWebSocket, socket as wsInstance } from './socket';
import { setSymbols } from '../rtk/slices/tradingSlice/tradingSlice';
import throttle from 'lodash.throttle';

let socket = wsInstance;
let pingInterval = null;
let reconnectTimeout = null;
let pingOnlyTimer = null;
let isReceivingOnlyPing = true;

const socketMiddleware = (store) => {
    return (next) => (action) => {
        if (action.type === 'socket/connect') {
            if (!socket || socket.readyState !== WebSocket.OPEN) {
                socket = createWebSocket();

                const throttledDispatch = throttle((data) => {
                    const { symbol, bid, ask, daily_high, daily_low, type } = data;

                    if (type !== 'ping') {
                        isReceivingOnlyPing = false;
                        store.dispatch(setSymbols({ symbol, bid, ask, daily_high, daily_low }));
                    } else {
                        // It's a ping-only message
                        isReceivingOnlyPing = true;
                    }
                }, 250);

                socket.onopen = () => {
                    console.log('WebSocket connected');

                    // Start sending pings
                    pingInterval = setInterval(() => {
                        if (socket.readyState === WebSocket.OPEN) {
                            socket.send(JSON.stringify({ type: 'ping' }));
                        }
                    }, 300);

                    // Start monitoring ping-only pattern
                    pingOnlyTimer = setInterval(() => {
                        if (isReceivingOnlyPing) {
                            console.warn('Only ping messages received — reconnecting WebSocket...');
                            socket.close(); // this will trigger onclose and auto-reconnect
                        }
                        isReceivingOnlyPing = true; // reset for next interval
                    }, 3000); // check every 3 seconds
                };

                socket.onmessage = (event) => {
                    try {
                        const rawMessages = event.data;

                        const messages = rawMessages
                            .split(/(?<=\})\s*(?=\{)/g)
                            .map((str) => {
                                const cleanedStr = str.replace(/(\d+),(\d+)/g, '$1.$2');
                                try {
                                    return JSON.parse(cleanedStr);
                                } catch (e) {
                                    console.warn("Skipping invalid JSON:", str);
                                    return null;
                                }
                            })
                            .filter(Boolean);

                        messages.forEach(throttledDispatch);
                    } catch (err) {
                        console.error('WebSocket message parsing error:', err);
                    }
                };

                socket.onclose = () => {
                    console.log('WebSocket disconnected');
                    clearInterval(pingInterval);
                    clearInterval(pingOnlyTimer);
                    reconnectTimeout = setTimeout(() => {
                        store.dispatch({ type: 'socket/connect' });
                    }, 1000);
                };

                socket.onerror = (error) => {
                    console.error('WebSocket error:', error);
                    clearInterval(pingInterval);
                    clearInterval(pingOnlyTimer);
                };
            }
        }

        if (action.type === 'socket/disconnect') {
            clearInterval(pingInterval);
            clearInterval(pingOnlyTimer);
            clearTimeout(reconnectTimeout);
            if (socket && socket.readyState === WebSocket.OPEN) {
                socket.close();
            }
        }

        return next(action);
    };
};

export default socketMiddleware;
